import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Toast } from '@/components/common/Toast';
import { useActivityHeartbeat } from '@/hooks/useActivityHeartbeat';

export const MainLayout = () => {
  useActivityHeartbeat();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar />
      
      <div className="lg:pl-64">
        <Header />
        
        <main className="container mx-auto px-4 py-4">
          <Outlet />
        </main>
      </div>

      <Toast />
    </div>
  );
};
